"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductListGrid = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const react_1 = require("react");
const ProductListGrid = ({ testId, children, ariaLabelledBy }) => {
    const isMobile = (0, flora_react_1.useIsMobile)();
    const productListTestId = testId ? `products-list-${testId}` : 'products-list';
    const isDesktop = (0, flora_react_1.useMinWidth)('992px');
    const templateColumns = (0, react_1.useMemo)(() => {
        if (isMobile)
            return '1fr 1fr';
        if (isDesktop)
            return '1fr 1fr 1fr 1fr 1fr 1fr';
        return '1fr 1fr 1fr 1fr';
    }, [isMobile, isDesktop]);
    return ((0, jsx_runtime_1.jsx)(flora_react_1.Box, Object.assign({ css: { width: '100%' }, "data-testid": productListTestId, className: productListTestId }, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Grid, Object.assign({ templateColumns: templateColumns, gap: isMobile ? '$2' : '$4', css: { padding: '$4 0' }, role: "list", "aria-labelledby": ariaLabelledBy }, { children: children })) })));
};
exports.ProductListGrid = ProductListGrid;
